import {ITheme} from 'contexts/ThemeContext';
import {useWindowDimensions} from 'react-native';

export default ({colors, typography}: ITheme) => {
  const {width, height} = useWindowDimensions();

  return {
    calendarContainer: {
      marginTop: 0,
    },
  };
};
